import { Suspense, lazy } from 'react';
import { useSelector } from 'react-redux';

import { noComponentOverride } from '@ezugi/utils';

import {
  isConfigLoadedSelector,
  isEvoPlayerSelector,
  videoConfigLoadedSelector,
} from '../../store/selectors';
import { GameVideoProps } from './types';

const EvoPlayer = lazy(() => import('./EvoPlayer'));
const NanoPlayer = lazy(() => import('./NanoPlayer'));

const DefaultRenderer = lazy(() => import('./Renderer'));

const NoComponent = lazy(noComponentOverride);

const GameVideo = (props: GameVideoProps) => {
  const isEvoPlayer = useSelector(isEvoPlayerSelector);
  const isConfigLoaded = useSelector(isConfigLoadedSelector);
  const videoConfigLoaded = useSelector(videoConfigLoadedSelector);

  const PlayerComponent = isEvoPlayer ? EvoPlayer : NanoPlayer;

  const components = {
    VideoContainer: props.components?.VideoContainer ?? DefaultRenderer,
    VideoUnderlay: props.components?.VideoUnderlay ?? NoComponent,
    VideoOverlay: props.components?.VideoOverlay ?? NoComponent,
  };

  return (
    <Suspense fallback={null}>
      {isConfigLoaded && videoConfigLoaded ? (
        <PlayerComponent {...props} components={components} />
      ) : null}
    </Suspense>
  );
};

export default GameVideo;
